import { CancellablePromise, get, put } from "@/api";
import type { Note } from "@/types";

export function getNote(methodId: string, searchWord: string): CancellablePromise<Note> {
  return get(`/v1/me/notes/${methodId}/${encodeURIComponent(searchWord)}`);
}

export function setNote(methodId: string, searchWord: string, note: string): CancellablePromise<void> {
  return put(`/v1/me/notes/${methodId}/${encodeURIComponent(searchWord)}`, { note });
}
